const content = {
  component: "PageTypeA",
  cssClass: "page-four",
  meta: {
    title: "National Instruments create high-growth culture",
    description:
      "National Instruments migrated to a cloud-based HR platform, enabling them to create a culture of high-growth.",
    og: {
      type: "website",
      title: "Cloud creates high-growth HR—read more",
      description: `National Instruments wanted to focus on several high-growth areas. But when you’re an international business, getting the right people in the right place can be hard. Using cloud, they moved performance management to a single platform, giving them a global view of skills, talent, and ability.`,
      image: require("../../assets/images/social/high-growth-culture-1200x630.jpg")
    },
    twitter: {
      card: "summary",
      title: "Read how cloud enabled National Instruments to nurture talent",
      description: `National Instruments created a high-growth culture, all thanks to an innovative cloud platform that put the right talent in the right place.`,
      site: "@Oracle",
      creator: "@Oracle",
      image: require("../../assets/images/social/high-growth-culture-300x300.jpg")
    }
  },
  title:
    "<span>National Instruments Create </span><span>High&#8209;Growth Culture</span>",
  heroImage: {
    preload: require("../../assets/images/bgs/high-growth-culture-pre.jpg"),
    loaded: require("../../assets/images/bgs/high-growth-culture.jpg"),
    mobile: require("../../assets/images/bgs/high-growth-culture-mobile.jpg")
  },
  // * the heroImageOptions are currently only required and supported when using the PageTypeA component
  heroImageOptions: {
    default: {
      customPosition: [false]
    },
    mobile: {
      customPosition: [false]
    },
    limtedHeight: {
      customPosition: [false]
    }
  },
  sections: [
    {
      component: "SectionCopy",
      content: {
        copy: `
        National Instruments has changed the way it manages talent to ensure that the right people worldwide are focusing on the company’s current growth priorities.
        `,
        type: "intro"
      }
    },
    {
      component: "SectionSeperator",
      content: {
        image: null
      }
    },
    {
      component: "SectionCopy",
      content: {
        copy: `
        <p>Under the leadership of Alex Davern, promoted to succeed company founder James Truchard as CEO in January 2017, the Austin, Texas-based maker of modular hardware platforms and system design software for engineers is focusing its talent on several high-growth areas, including semiconductor testing, 5G wireless, connected vehicles, and the industrial Internet of Things.</p>
        <p>As part of that effort, National Instruments’ HR team designed a new performance management process and built a new cloud-based HR platform. A key platform feature is “cascaded goal-setting,” which helps HR and line of business managers see what employees are working on, track their performance, and help tie employee compensation to contributions. “This helps us create a more performance-driven culture that rewards individuals for their contributions,” says Cate Prescott, vice president of global human resources.</p>
        `,
        type: "default"
      }
    },
    {
      component: "SectionQuote",
      content: {
        quote: `At some level, it’s great that each country has taken the initiative to manage individual performance. But with that as context, it’s really challenging to manage consistent standards and use the outcomes in any meaningful way. We needed a new system that could help us not only capture more data, but glean more insights from that data as well.`,
        author: `Cate Prescott`,
        position: `Vice President of Global Human Resources, National Instruments`,
        type: "quote",
        backgroundImage: require("../../assets/images/bgs/HighGrowthCulture_NationalInstruments_bg.jpg")
      }
    },
    {
      component: "SectionCopy",
      content: {
        copy: `
          <p>National Instruments first evaluated the strengths and weaknesses of its talent bench for each business function, site, and country. Because all of the employee data is now available in the cloud, HR and LOB managers can, for example, check on what software engineers in Germany, India, or China are working on and make sure they get recognized—or reassigned to higher-priority projects.</p>
          <p>“The opportunity to see talent at that level wasn’t possible before,” says Wendy Cottrell, head of HR information systems for National Instruments. For one thing, regional HR teams didn’t have visibility at a global level. “We had no idea what the caliber of our talent was around the world,” she says.</p>
          <p>Having that global view became especially important as National Instruments evolved from a product-focused sales approach to a more customer-centric strategy.</p>
        `,
        type: "default"
      }
    },
    {
      component: "SectionImage",
      content: {
        image: require("../../assets/images/content/HighGrowthCulture_InlineImage.jpg"),
        alt: "",
        type: "image"
      }
    },
    {
      component: "SectionCopy",
      content: {
        copy: `
          <p>In the past, the company’s sales and marketing people focused on fulfilling demand for individual products. “Establishing a new strategy meant defining new expectations for how we partner with customers to solve more-complex, system-level challenges,” says Jason Green, National Instruments vice president of sales and marketing for the Americas. “We also needed to motivate people by developing new roles, with new expectations and a new way of selling that demanded a deep mastery of the craft.”</p>
          <p>Green now documents those expectations with the skills and competencies required for each role; and it develops a nine-box talent review process for each team, which tracks the potential and performance of each individual and establishes succession plans.</p>
          <p>“We’re now able to have ongoing conversations with people based on clear expectations, track their performance, and continuously develop their abilities throughout the year,” he says. “Without the tools in Oracle HCM Cloud, we wouldn’t be able to adapt, we wouldn’t be able to scale.”</p>
        `,
        type: "default"
      }
    },
    {
      component: "SectionCallToAction",
      content: {
        title: `Transform your business with Oracle`,
        ctas: [
          {
            image: require("../../assets/images/svgs/report.svg"),
            copy: "Decision makers and technology report",
            url:
              "https://www.oracle.com/uk/applications/human-capital-management/driving-hr-innovation.html?source=:ow:o:cs:mt:RC_EMMK181024P00070C0001:YTTFY19_HR_AW_HI_CM_UK_C33_Q33_RT&intcmp=:ow:o:cs:mt:RC_EMMK181024P00070C0001:YTTFY19_HR_AW_HI_CM_UK_C33_Q33_RT",
            buttonCopy: "Read report"
          },
          {
            image: require("../../assets/images/svgs/servers.svg"),
            copy: "Try out Oracle Cloud Solutions",
            url:
              "https://go.oracle.com/LP=43623?qt=saas_hcm_hr_SimplifytheHumanResourcesExperiencewithaGlobalHRSolution&src1=:ow:o:cs:mt:RC_EMMK181024P00070C0001:YTTFY19_HR_CT_QT_CM_UK_C38_Q34&intcmp=WWMK161025P00095:ow:o:cs:mt:RC_EMMK181024P00070C0001:YTTFY19_HR_CT_QT_CM_UK_C38_Q34",
            buttonCopy: "Try now"
          }
        ],
        type: "cta"
      }
    }
  ]
};

export default content;
